import React, { Component, Fragment } from 'react';
import EditUserDetailsForm from './editUserDetailsForm';
import ChangePasswordForm from './changePasswordForm';
import './editUserDetails.css';
import { connect } from 'react-redux';
import { searchCityByTerm, searchCountyByTerm } from '../../../SHARED/actions/geolocation.actions';
import {updateUserDetails} from '../../actions/editprofile.actions';
import {changePassword} from '../../actions/user.actions';
import moment from 'moment';
import 'moment/locale/ro';
import {withRouter} from "react-router";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import FaSignOut  from 'react-icons/lib/fa/sign-out';
import {isEmpty} from '../../helpers/general.helper';
const months = [
    'ianuarie', 'februarie', 'martie', 'aprilie',
    'mai', 'iunie', 'iulie', 'august',
    'septembrie', 'octombrie', 'noiembrie', 'decembrie'
];

class EditUserDetails extends Component {

    logout = () => {
        window.localStorage.clear();
        this.props.history.push("/autentificare");
    }
    
    getMonths = () => {
        return months.map((month, index) => (
            <option key={index} value={index + 1}>{month}</option>
        ));
    };

    getDays = () => {
        let days = [];
        for (let i = 1; i <= 31; i++) {
            days.push(i);
        }
        return days.map((day, index) => (
            <option key={index} value={index}>{day}</option>
        ));
    };

    getDropdownValues = (min, max) => {
        let numbers = [];
        for (let i = min; i <= max; i++) {
            numbers.push(i);
        }
        return numbers.map((number, index) => (
            <option key={index} value={number}>{number}</option>
        ));
    };

    editUserDetails = (data) => {
        const userDetails = {
            first_name: data.first_name,
            last_name: data.last_name,
            email: data.email,
            date_of_birth: moment(`${data.year}-${data.month}-${data.day}`).format("YYYY-MM-DD")
        }
        this.props.updateUserDetails(userDetails);
    }

    changePassword = (data) => {
        const payload = {
            old_password: data.oldPassword,
            new_password: data.passwordConfirm
        }
      this.props.changePassword(payload);
    }

    getContent = () => {
        // if(this.props.userDetails !==null && !isEmpty(this.props.userDetails)){
            return <Fragment> 
                <FaSignOut className="profile-logout-icon" onClick={this.logout} />
                <Tabs>
                    <TabList>
                        <Tab>MODIFICA-TI CONTUL</Tab>
                        <Tab>SCHIMBA PAROLA</Tab>
                    </TabList>
                    <TabPanel>
                        <EditUserDetailsForm
                            onSubmit={this.editUserDetails}
                            getDropdownValues={this.getDropdownValues}
                            getMonths={this.getMonths}
                            errors={this.props.errors}
                            initialValues={this.props.initialValues}
                        />
                    </TabPanel>
                    <TabPanel>
                        <div className="error-holder">
                            {this.props.errors.error}
                        </div>
                        <ChangePasswordForm
                            onSubmit={this.changePassword}
                        />
                    </TabPanel>
                </Tabs>
            </Fragment>
        // } else {
        //     return <Fragment>
        //         <div>
        //             <FaSignOut className="profile-logout-icon" onClick={this.logout} />
        //         </div>
        //         <EditUserDetailsForm
        //             onSubmit={this.editUserDetails}
        //             getDropdownValues={this.getDropdownValues}
        //             getMonths={this.getMonths}
        //             errors={this.props.errors}
        //             initialValues={this.props.initialValues}
        //         />
        //     </Fragment>
        // }
    }

    render(){
        return (
            <div className="edit-user-details">      
                {this.getContent()}        
            </div>
        );
    }
}

const mapStateToProps = state => {
    let initialValues = {title: ''};
    if(state.profile.userDetails === null || isEmpty(state.profile.userDetails)) {
        initialValues = { 
                ...state.profile.facebookOrGoogleResponse,
                month: moment().format('MMMM'),
                day: moment().format('DD'),
                year: moment().format('YYYY'),
                title: "Completare informatii",
            }
    }
    else{
        const date_format = moment(state.profile.userDetails.date_of_birth, 'YYYY-MM-DD');
        initialValues = { 
            ...state.profile.userDetails,
            month: state.profile.userDetails ? date_format.format('MMMM'): '',
            day: state.profile.userDetails ? date_format.format('D') : '',
            year: state.profile.userDetails ? date_format.format('YYYY'): '',
            title: "Modifica-ti contul"
        }
    }
return {
    cities: state.geolocation.cities,
    counties: state.geolocation.counties,
    userDetails: state.profile.userDetails,
    errors: state.user.errors,
    initialValues,
}}
export default withRouter(connect(mapStateToProps, {searchCityByTerm, searchCountyByTerm, updateUserDetails, changePassword})(EditUserDetails));



// WEBPACK FOOTER //
// ./src/SHARED/components/editUserDetails/editUserDetails.component.js